<template>
  <div class="banner">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="be-you-logo">
            <router-link :to="{name: 'Index'}">
              <img src="/static/img/be-you-white-logo.png">
            </router-link>
          </div>
          <h2>Si <span class="green">dobrodruh</span>, <span class="pink-light">maškrtník</span>, <span class="yellow">hviezda každej párty</span> alebo <span class="blue-light">dnešok preleňošíš v posteli</span>?</h2>
        </div>
      </div>
    </div>
    <div class="logo-vertical">
      <router-link :to="{name: 'Index'}">
        <img :src="'/static/img/logo-vertical.png'">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .banner {
    background: $color-blue;
    text-align: center;
    color: $color-white;
    padding: 60px 0 45px 0;
    overflow: hidden;
    h2 {
      font-size: 36px;
      font-weight: 500;
      line-height: 1.3;
      max-width: 710px;
      text-align: center;
      display: inline-block;
      padding: 0 20px;
      .green {
        color: $color-green;
      }
      .pink-light {
        color: $color-pink-light;
      }
      .yellow {
        color: $color-yellow;
      }
      .blue-light {
        color: $color-blue-light;
      }
    }
    .be-you-logo {
      margin-bottom: 60px;
    }
    .logo-vertical {
      position: absolute;
      top: 20px;
      right: 0;
    }
    p {
      font-size: 24px;
    }
    @media (max-width: $breakpoint-sm) {
      padding: 20px 0;
      h2 {
        font-size: 24px;
        line-height: 30px;
      }
      .be-you-logo {
        img {
          width: 200px;
        }
      }
      .logo-vertical {
        img {
          width: 24px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/Banner.vue